<template>
  <div>
    <questionnaire
      :key="new Date().getTime()"
      country="Singapore"
      :applymentId="detail.id"
      :applymentStatus="detail.applymentStatus"
      :questionnaire="detail.questionnaire"
      :businessType="detail.businessType"
      :fundInfoList="detail.fundInfoList || []"
      :businessGenre="detail.businessGenre"
      :registeredOfficeType="detail.registeredOfficeType"
      :registeredOfficeAddress="detail.registeredOfficeAddress"
      :registeredOfficeCity="detail.registeredOfficeCity"
      :registeredOfficeCountry="detail.registeredOfficeCountry"
      :registeredOfficePostalCode="detail.registeredOfficePostalCode"
      :registeredOfficeId="detail.registeredOfficeId"
      :nativeRegisteredAddress="nativeRegisteredAddress"
      :isNeedNomineeDirector="isNeedNomineeDirector"
      :hasNomineeDirector="detail.hasNomineeDirector"
    />
    <shareholders-detail
      class="mt40"
      stepName="kycQuestionnaire"
      country="Singapore"
      :applymentId="detail.id"
      :applymentStatus="detail.applymentStatus"
      :fundInfoList="detail.fundInfoList || []"
      :companyMemberList="detail.companyMemberList"
      :companyFundMemberList="detail.companyFundMemberList"
      :hasNomineeDirector="detail.hasNomineeDirector"
      :businessType="detail.businessType"
      :appointNomineeDirector="detail.questionnaire.appointNomineeDirector || { type: null, name: null }"
      :supplierList="detail.supplierList"
      :quotationList="detail.quotationList || []"
      :headline="
        detail.businessType === 'FUND_ADMIN_CUSTOMIZED'
          ? `Information of the proposed fund manager's officer(s)`
          : `Information of the proposed company's officer(s)`
      "
      :isNeedNomineeDirector="isNeedNomineeDirector"
      v-if="
        detail.businessType === 'SERVICE_TRANSFER' ||
        detail.businessType === 'COMPREHENSIVE_CUSTOMIZED' ||
        detail.businessType === 'FUND_ADMIN_CUSTOMIZED'
      "
    />
  </div>
</template>

<script>
import Questionnaire from "../common/questionnaire";
import ShareholdersDetail from "../common/shareholdersDetail";
export default {
  components: {
    Questionnaire,
    ShareholdersDetail,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    nativeRegisteredAddress: {
      type: Array,
      default: () => [],
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
  },
};
</script>
